import {
  groupClassToolDef,
  type GroupClassToolDef,
} from '@form-factory/schema/contracts';
import { Trans, useLingui } from '@lingui/react/macro';
import { CalendarRangeIcon, LogInIcon } from 'lucide-react';

import { ToolNoDataError } from './components/ToolNoDataError';
import { getToolContent } from './utils/contentTranslation';
import { createToolComponent } from '../../toolRegistry';
import { useChatRenderer } from '../ChatRendererProvider';
import { Markdown } from '../Markdown';
import { Message } from '../ui';

export const GroupClassesTool = createToolComponent(
  {
    schema: {
      content: groupClassToolDef,
    },
  },
  ({ toolCall, state, content }) => {
    // Don't render during streaming
    if (state === 'call' || state === 'call-partial') {
      return null;
    }

    // Get data - ToolProvider already unwrapped it
    const data = state === 'result' && content ? content : toolCall.args;
    const { navigate, isEfitnessAuthenticated } = useChatRenderer();
    const { i18n } = useLingui();

    // Type guard to ensure data has content property
    const typedData = data as GroupClassToolDef | undefined;

    if (
      !typedData?.content &&
      (state === 'call-complete' || state === 'result')
    ) {
      return <ToolNoDataError />;
    }

    return (
      <Message.BubbleGroup>
        <Message.Bubble>
          <Markdown>
            {getToolContent(typedData?.content || '', 'group_class', i18n)}
          </Markdown>
          {!isEfitnessAuthenticated?.() && (
            <button
              type='button'
              onClick={() => navigate?.('signIn')}
              className='w-full my-3 flex flex-row items-center justify-center gap-2 rounded-lg bg-chat-secondary px-3 py-2.5 text-chat-secondary-foreground shadow drop-shadow transition-all enabled:hover:scale-105 enabled:hover:opacity-70 enabled:active:scale-100'
            >
              <LogInIcon className='size-5' />
              <Trans>Login</Trans>
            </button>
          )}
          <button
            type='button'
            onClick={() => navigate?.('groupClasses')}
            className='w-full my-3 flex flex-row items-center justify-center gap-2 rounded-lg bg-amber-500/20 px-3 py-2.5 text-amber-500 shadow drop-shadow transition-all enabled:hover:scale-105 enabled:hover:opacity-70 enabled:active:scale-100'
          >
            <CalendarRangeIcon className='size-5' />
            <Trans>Group classes</Trans>
          </button>
        </Message.Bubble>
      </Message.BubbleGroup>
    );
  },
);
